import { createSlice } from '@reduxjs/toolkit';
import { getShopMenu } from './thunk';
import { normalizeShopMenuResponse } from '../../../helpers/menuAvailability';

export const initialState = {
    shopMenu: null,
    loading: {
        getShopMenu: false,
    },
    success: {
        getShopMenu: false,
    }
};

const ShopMenuSlice = createSlice({
    name: 'ShopMenuSlice',
    initialState,
    reducers: {
        clearState: (state) => {
            state.shopMenu = null;
            state.loading = {
                getShopMenu: false,
            };
            state.success = {
                getShopMenu: false,
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getShopMenu.pending , (state) => {
            state.shopMenu = null;
            state.loading.getShopMenu = true;
            state.success.getShopMenu = false;
        });
        builder.addCase(getShopMenu.fulfilled, (state, action) => {
            const data = normalizeShopMenuResponse(action.payload.data);
            if (data?.shop) {
                const hasImage = data.shop.hasImage ?? data.shop.has_image;
                data.shop.hasImage = hasImage !== false;
            }
            state.shopMenu = data;
            state.loading.getShopMenu = false;
            state.success.getShopMenu = true;
        });
        builder.addCase(getShopMenu.rejected, (state, action) => {
            state.shopMenu = null;
            state.loading.getShopMenu = false;
            state.success.getShopMenu = false;
        });
    },
});

export const { clearState } = ShopMenuSlice.actions;
export default ShopMenuSlice.reducer;